module.exports = __webpack_public_path__ + "img/SWP_Shield_01 (2).70e515d5.png";